module.exports = __webpack_public_path__ + "static/media/icon_huodon_hz.0335575d.png";